import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import RentalPlan from '../helpers/rental_plan'
import SalePlan from '../helpers/sale_plan'
import lrhd from '../../assets/images/lr-hd.svg'

import styles from '../../assets/stylesheets/pages/cart/shipping.module.scss'

const LensrentalsHD = props => {
  const {
    cartPlan: {
      shipType,
      shipping
    }
  } = props

  return (
    <div
      className={cx(
        'lensrentals-hd',
        styles.shipping__box,
        styles.shipping__lrhd
      )}
    >
      <h3>Lensrentals HD:</h3>
      <img src={lrhd} alt='Lensrentals HD' />
      <p>
        {(shipping?.shippingMethod?.includes('FedEx') && shipType !== 'pickup')
          ? `Save ${shipping.discount} on the shipping of this order, and get free FedEx Standard Shipping for a year with Lensrentals HD.`
          : 'Get free FedEx Standard Shipping for a year with Lensrentals HD.'}
        <a href='/lrhd'>Learn More</a>
      </p>
    </div>
  )
}

LensrentalsHD.propTypes = {
  cartPlan: PropTypes.oneOfType([
    PropTypes.instanceOf(RentalPlan),
    PropTypes.instanceOf(SalePlan)
  ]).isRequired
}

export default LensrentalsHD
